<div class="feedback-button">
  <fa-icon [icon]="faCommentExclamation" class="fa-light" />
  <a
    href="mailto:supportoefenen@lyceo.nl?{{ mailToQueryParams() }}"
    target="_blank"
    >Foutje gezien? Laat het ons weten!</a
  >
</div>
